import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MixpanelEventMapperService {

  mapUser(user) {
    return {
      role: user.role
    };
  }

  mapStep(step) {
    return {
      step_id: step.Id,
      step_name: step.Title,
      course: step.Course.Title
    };
  }

  mapLevel(level) {
    return {
      level: level
    };
  }

  mapTypology(typology: string): string{
    switch(typology){
      case 'actividades':
        typology = Typology.ACTIVIDADES;
        break;
      case 'ejercicios':
        typology = Typology.EJERCICIOS;
        break;
      case 'autoevaluacion':
        typology = Typology.AUTOEVALUACION;
        break;
      case 'recursos':
        typology = Typology.RECURSOS;
      break;
      case 'pruebas':
        typology = Typology.PRUEBAS;
        break;
      default: typology = Typology.ACTIVIDADES;
    }
    return typology;
  }

  mapFeature(feature: string): string{
    switch(feature){
      case 'isSolutionaryAvailable':
        feature = Feature.SOLUTIONARY;
        break;
      case 'isHidden':
        feature = Feature.HIDDEN;
        break;
      case 'isEvaluable':
        feature = Feature.EVALUABLE;
      break;
    }
    return feature;
  }
}

export enum Typology {
  ACTIVIDADES = 'activity',
  EJERCICIOS = 'exercise',
  AUTOEVALUACION = 'autoevaluation',
  RECURSOS = 'resource',
  PRUEBAS = 'test'
}

export enum Feature {
  EVALUABLE = 'evaluable',
  HIDDEN = 'hidden',
  SOLUTIONARY = 'solutionary'
}
